import React, { useEffect, useState } from 'react';

import { useFingerprint } from '@/hooks/useFingerprint';
import { useEnvironment } from '@/providers/EnvironmentProvider';
import { Capacitor } from '@capacitor/core';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';

const isCapacitor = Capacitor.isNativePlatform();

interface DeeplinkGetRes {
	destinationUrl?: string;
}

interface DeepLinkParams {
	width?: string;
	height?: string;
	platform?: string;
	language?: string;
}

const checkDeeplink = async (
	url: string,
	params: DeepLinkParams,
): Promise<DeeplinkGetRes | undefined> => {
	// Check if any value is falsy. If it is, don't check for a deeplink as
	// we can't be certain that the device is the same
	if (Object.values(params).map(Boolean).includes(false)) {
		return;
	}
	try {
		const res = await axios.post<DeeplinkGetRes>(
			`${url}/deeplink/consume`,
			params,
		);
		return res.data;
	} catch (err) {
		console.error('Could not get deeplink', err);
		return;
	}
};

const RedirectDeeplink = () => {
	const {
		api: { url },
	} = useEnvironment();
	const fingerprint = useFingerprint();
	const { enqueueSnackbar } = useSnackbar();
	const navigate = useNavigate();

	useEffect(() => {
		const runPromise = async () => {
			const res = await checkDeeplink(url, fingerprint);
			if (res?.destinationUrl) {
				enqueueSnackbar('Continuing journey from previous session!');
				navigate(res.destinationUrl);
			}
		};
		// Run the redirect only if this is being executed
		// in the mobile app
		if (isCapacitor) {
			runPromise();
		}
	}, [url, fingerprint, enqueueSnackbar, navigate]);

	return null;
};

export default RedirectDeeplink;
